import $ from 'jquery';
import Page from './page.js';
import SearchEvents from './events';
import { wait } from '../../utils/helpers';
import { isChatInitialized, sendPostMessage, closeChatAfterInactivity, supportedProducts } from '../chat';

// ie11 polyfills
if (!Array.prototype.includes) {
  Array.prototype.includes = function(term) {
    return this.indexOf(term) !== -1;
  };
}
function CustomEvent ( event, params ) {
  params = params || { bubbles: false, cancelable: false, detail: undefined };
  var evt = document.createEvent( 'CustomEvent' );
  evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
  return evt;
}
if ( typeof window.CustomEvent !== 'function' ) {
  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
}

/* Controller
 *
 * Handles sending and interpreting API search
 * results. Sets page states using page class.
 */
class Controller {
  constructor(options) {
    const { form, prodId, queryId, docTypesId } = options;

    this.page = new Page();
    this.searching = false; // if page has request processing

    this.prodId = prodId;
    this.queryId = queryId;
    this.docTypesId = docTypesId;

    this.form = $('#' + form);
    this.duration = {'start': 0, 'end': 0 };

    this.form.submit(this.submit.bind(this));

    this.preload();
  }

  // check doc for preloaded values & run
  preload() {
    let product = document.getElementById(this.prodId);
    let query = document.getElementById(this.queryId);
    let docTypes = document.getElementById(this.docTypesId);

    product = product ? product.value : '';
    query = query ? query.value : '';
    docTypes = docTypes && docTypes.value ? docTypes.value.split(',') : '';

    $('select.product-field').val(product).trigger('change');
    $('input.query-field').val(query);
    if (docTypes.length) {
      $('[name="doc-types[]"]').each(function () {
        if (docTypes.includes($(this).val())) {
          $(this).prop('checked', true);
        } else {
          $(this).prop('checked', false);
        }
      });
    }

    if (product && docTypes.length && $('.js-search-form').length) {
      this.ajax(query, product, docTypes);
    }
  }

  // api submit
  submit(e) {
    e.preventDefault();

    if ( ! this.form.valid() || this.searching) {
      return false;
    }

    this.duration.start = performance.now();

    const fields = {};
    this.form.serializeArray().map( (field) => {
      fields[field.name] = field.value;
    });

    const query = fields['query'].replace(/[^A-Za-z0-9- ]/g, '');
    const product = fields['Product'].replace(/[^A-Za-z0-9- ]/g, '');
    const docOptions = document.querySelectorAll('[name="doc-types[]"]:checked');
    const docTypes = [];

    for (const docOption of docOptions) {
      docTypes.push(docOption.value);
    }

    this.ajax(query, product, docTypes);
  }

  // make ajax request
  ajax(query, product, docTypes) {
    this.page.loading(query, product, docTypes);
    this.searching = true;
    const failAfter = 10000;
    const url = new URL(document.URL);
    const engine = url.searchParams.get('engine');

    $.ajax({
      type: 'POST',
      url: '/search/endpoint.php',
      data: {
        'query': query,
        'config': {
          'where': {
            'products': product.toLowerCase(),
            'es_doc_type': docTypes,
          },
          'engine': engine
        }
      },
      timeout: failAfter,
      success: this.success.bind(this, query, product),
      error: () => this.fail,
      dataType: 'json',
    })
      .done(() => {
        if (docTypes.includes('lrd')) {
          $.ajax({
            type: 'POST',
            url: '/search/chat-endpoint.php',
            data: {
              'query': query,
              'product': product.toUpperCase(),
            },
            timeout: failAfter,
            success: this.chatSuccess.bind(this),
            dataType: 'json',
          });
        }
      });

    this.timeout = setTimeout(() => {
      this.fail();
    }, failAfter);

    return true;
  }

  chatSuccess(result) {
    if (result.status !== 'success' || ! result.shouldOpen) { return; }

    const product = result.utterance.split(' ')[0];

    wait(isChatInitialized)
      .then(() => {
        setTimeout(() => {
          if ( window.AiseraChatCanOpen && supportedProducts.includes(product.toLowerCase()) ) {
            sendPostMessage({
              type: 'aisera.webchat.open',
              text: result.utterance,
            });

            closeChatAfterInactivity();
          }
        }, 200);
      });
  }

  checkWords(query, product) {
    const commonBannedWords = window.projectGlobals.bannedWords;
    const commonRestrictedWords = window.projectGlobals.restrictedWords;
    let productRestrictedWords = window.projectGlobals.products[product]['restricted-words'];

    const words = {
      restricted: [],
      valid: [],
    };

    // split restricted words that consist of more than one word into separate words
    productRestrictedWords = [...new Set(productRestrictedWords.map(word => word.split(' ')).flat())];

    const operators = ['and', 'or'];
    const terms = query
      .split(' ')
      .map((term) => term.toLowerCase())
      .filter(
        (term) =>
          !!term &&
          !operators.includes(term) &&
          !commonBannedWords.includes(term)
      );

    terms.forEach(term => {
      if (
        commonRestrictedWords.includes(term) ||
        productRestrictedWords.includes(term)
      ) {
        words.restricted.push(term);
      } else {
        words.valid.push(term);
      }
    });

    return words;
  }

  // called after failed AJAX
  fail() {
    // client wants fails to have no results
    //this.page.fail();
    this.page.none();
    this.searching = false;
    clearTimeout(this.timeout);
    window.AiseraChatCanOpen = false;
  }

  // called after successful AJAX
  success(query, prod, result) {
    const failed = result['status'] === 'fail';
    const count = (failed) ? 0 : result['meta']['page']['total_results'];
    const data = (failed) ? [] : result['data'];
    const words = this.checkWords(query, prod.toLowerCase());
    window.AiseraChatCanOpen = false;

    clearTimeout(this.timeout);
    this.duration.end = performance.now();
    this.searching = false;

    // create search event
    let ev = new Event('search');
    ev.detail = {
      'product': prod,
      'status': null,
    };

    // Debug info
    this.page.debug(result);

    // Search results
    if ( !count ) {
      this.page.none();
      ev.detail.status = 'empty';
    } else if ( !words.valid.length && words.restricted.length ) {
      if ( count <= 7 ) {
        this.page.success(data, count);

        if ( result.isAiseraHasAnswer && supportedProducts.includes(prod.toLowerCase()) ) {
          wait(isChatInitialized)
            .then(() => {
              sendPostMessage({
                type: 'aisera.webchat.open',
                text: `${prod.toUpperCase()} ${query}`,
              });

              closeChatAfterInactivity();
            });
        }

        ev.detail.status = 'results-' + count;
      } else {
        this.page.exceed();
        ev.detail.status = 'exceed';
      }
    } else if ( words.valid.length ) {
      if ( count <= 7 ) {
        this.page.success(data, count);
        ev.detail.status = 'results-' + count;
      } else {
        this.page.over(data, count);
        ev.detail.status = 'results-over';
      }
      const lrdLength = data.filter(item => item.es_doc_type.raw === 'lrd').length;

      if ( lrdLength ) {
        window.AiseraChatCanOpen = true;
      }
    }

    setTimeout(() => {
      const s = new SearchEvents();
      s.init();

      // Dispatch search event
      document.dispatchEvent(ev);
    }, 300);
  }
}


export default Controller;



// WEBPACK FOOTER //
// ./src/assets/js/project/search/driver.js